import AssessmentResult from './AssessmentResult'
export default AssessmentResult
